import React, { useState } from "react";
import moment from "moment";

const DashboardTab = ({
  userHeader,
  userProducts,
  loading,
  totalDocument,
  filter,
  setFilter,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const totalItems = totalDocument;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
      setFilter({ ...filter, page: page.toString() });
    }
  };

  const currentItems = userProducts;

  const generatePageNumbers = () => {
    const pages = new Set();

    // Always include the first page
    pages.add(1);

    // Include "..." before middle pages if needed
    if (currentPage > 3) pages.add("...");

    // Include pages around the current page
    const start = Math.max(2, currentPage - 1);
    const end = Math.min(totalPages - 1, currentPage + 1);
    for (let i = start; i <= end; i++) {
      pages.add(i);
    }

    // Include "..." after middle pages if needed
    if (currentPage < totalPages - 2) pages.add("...");

    // Always include the last page
    if (totalPages > 1) {
      pages.add(totalPages);
    }

    return Array.from(pages);
  };

  const paginationNumbers = generatePageNumbers();

  return (
    <div className="relative bg-card overflow-x-auto shadow-md sm:rounded-lg m-1">
      {loading ? (
        <div className="text-center text-gray-500">Loading...</div>
      ) : totalItems === 0 ? (
        <div className="text-center text-gray-500">No products found</div>
      ) : (
        <>
          <table className="w-full text-sm text-left rtl:text-right bg-card text-gray-500 dark:text-gray-400">
            <thead className="text-xs text-text uppercase bg-[#02256d] text-white">
              <tr>
                {userHeader.map((header, index) => (
                  <th key={index} scope="col" className="px-6 py-3">
                    {header.label || header.key}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {currentItems.map((product, index) => (
                <tr
                  key={index}
                  className="bg-card border-b dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
                >
                  <th scope="row" className="px-6 py-4 font-medium whitespace-nowrap">
                    {product?.userId?.username} <br />
                    {product.userId?.email}
                  </th>
                  <td className="px-6 py-4">{product?.types}</td>
                  <td className="px-6 py-4">{product?.message}</td>
                  <td className="px-6 py-4">
                    {moment(product?.createdAt).format("DD/MM/YYYY HH:mm")}
                    <br />
                    {moment(product?.createdAt).fromNow()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <nav className="flex items-center justify-between m-4" aria-label="Table navigation">
            <span className="text-sm font-normal text-black dark:text-gray-400">
              Showing{" "}
              <span className="font-semibold text-text">
                {(currentPage - 1) * itemsPerPage + 1} -{" "}
                {Math.min(currentPage * itemsPerPage, totalItems)}
              </span>{" "}
              of <span className="font-semibold text-text">{totalItems}</span>
            </span>
            <ul className="inline-flex -space-x-px text-sm h-8">
              {/* Previous Button */}
              <li>
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                  className="flex items-center justify-center px-3 h-8 text-gray-500 bg-white border border-gray-300 rounded-l-lg hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700"
                >
                  Previous
                </button>
              </li>

              {/* Page Numbers */}
              {paginationNumbers.map((page, index) => (
                <li key={index}>
                  {page === "..." ? (
                    <span className="flex items-center justify-center px-3 h-8 text-gray-500 bg-white border border-gray-300">
                      ...
                    </span>
                  ) : (
                    <button
                      onClick={() => handlePageChange(page)}
                      className={`flex items-center justify-center px-3 h-8 ${
                        currentPage === page
                          ? "text-white bg-[#02256d]"
                          : "text-gray-500 bg-white"
                      } border border-gray-300 hover:bg-gray-950 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700`}
                    >
                      {page}
                    </button>
                  )}
                </li>
              ))}

              {/* Next Button */}
              <li>
                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  className="flex items-center justify-center px-3 h-8 text-gray-500 bg-white border border-gray-300 rounded-r-lg hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700"
                >
                  Next
                </button>
              </li>
            </ul>
          </nav>
        </>
      )}
    </div>
  );
};

export default DashboardTab;
